<script setup>
const props = defineProps({
    currentIndex: {
        type: Number,
        required: true,
    },
    numberOfSlides: {
        type: Number,
        required: true,
    },
    stepLength: {
        type: String,
    },
    carouselWidth: {
        type: [String, Number],
    },
    stop: {
        type: Boolean,
        default: false,
    },
});

const rightValue = computed(() => {
    if (props.currentIndex == 0) {
        return '0%';
    } else {
        return `${props.currentIndex * 100}%`;
    }
});
</script>

<template>
    <section class="simple-carousel">
        <TransitionGroup tag="ul" name="simple" :style="`width: ${carouselWidth}; margin-left: -${stepLength}`"
            ref="itemsWrapperRef">
            <slot :rightValue="rightValue"></slot>
        </TransitionGroup>
    </section>
</template>
<!-- :style="`width: ${(numberOfSlides - 1) * 29 + 41}rem; margin-left: -${currentIndex * 29}rem`" -->
<style lang="scss">
.simple-carousel {
    overflow: hidden;

    ul {
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 100%;
        transition: 0.33s ease-in-out;

        li {
            width: 100%;
            flex-grow: 1;
            display: inline-flex;
        }
    }

    img,
    li,
    .mess-image {
        transition: width 0.5s ease 0s, height 0.5s ease 0.5s;

        position: relative;
    }

    @media (max-width: $tablet) {
        ul {
            li {
                display: inline-block;
            }
        }
    }
}
</style>
